import React, { useEffect, useState } from 'react';
import { platformAPI } from '../services/api';
import '../styles/ChallengeModals.css';

function ChallengeCreate({ userBalance, onCreate, onCancel }) {
  const [wager, setWager] = useState(50);
  const [numGames, setNumGames] = useState(1);
  const [minimumWager, setMinimumWager] = useState(10);
  const [chargePercent, setChargePercent] = useState(7);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const res = await platformAPI.getSettings();
        const nextMin = Number(res?.data?.minimumWager);
        const nextCharge = Number(res?.data?.chargePercent);

        if (Number.isFinite(nextMin) && nextMin >= 0) {
          setMinimumWager(nextMin);
          setWager((prev) => Math.max(nextMin, Number(prev) || 0));
        }
        if (Number.isFinite(nextCharge) && nextCharge >= 0) {
          setChargePercent(nextCharge);
        }
      } catch (err) {
        console.error('Failed to load platform settings:', err);
      }
    };

    loadSettings();
  }, []);

  const balance = userBalance || 0;
  const totalRisk = wager * numGames;
  const canCreate = balance > 0 && totalRisk <= balance && wager >= minimumWager;

  const handleCreate = () => {
    setError(null);

    if (wager < minimumWager) {
      setError(`Minimum wager is ${minimumWager} wikipenny`);
      return;
    }

    if (totalRisk > balance) {
      setError(`Insufficient balance. You need ${totalRisk} wikipenny`);
      return;
    }

    onCreate(wager, { numGames });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content create-challenge-modal">
        <div className="modal-header">
          <h2>Real Challenge</h2>
          <button className="close-btn" onClick={onCancel}>✕</button>
        </div>

        <div className="modal-body">
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label>Wager</label>
            <div className="input-with-unit">
              <input
                type="number"
                value={wager}
                onChange={(e) => {
                  const numericValue = Number.parseInt(e.target.value, 10);
                  setWager(Number.isFinite(numericValue) ? numericValue : 0);
                }}
                min={minimumWager}
                step="10"
              />
              <span className="unit">wikipenny</span>
            </div>
            <small>Minimum {minimumWager} wikipenny</small>
            <small>Tip: Enter any amount, but creation is blocked below the minimum.</small>
          </div>

          <div className="form-group">
            <label>Number of games</label>
            <div className="input-with-unit">
              <input
                type="number"
                value={numGames}
                onChange={(e) => {
                  const numericValue = Number.parseInt(e.target.value, 10);
                  const safeValue = Number.isFinite(numericValue) ? numericValue : 1;
                  setNumGames(Math.min(3, Math.max(1, safeValue)));
                }}
                min="1"
                max="3"
                step="1"
              />
              <span className="unit">games</span>
            </div>
            <small>Allowed: 1 to 3 games</small>
          </div>

          <div className="summary">
            <div className="summary-row">
              <span>Wager:</span>
              <strong>{wager} wikipenny</strong>
            </div>
            <div className="summary-row">
              <span>Platform fee:</span>
              <strong>{chargePercent}%</strong>
            </div>
            <div className="summary-row">
              <span>Game Type:</span>
              <strong>{numGames === 1 ? 'Single Match' : `${numGames} Match Series`}</strong>
            </div>
            <div className="summary-row total">
              <span>Total at Risk:</span>
              <strong className={totalRisk > userBalance ? 'error' : ''}>
                {totalRisk} wikipenny
              </strong>
            </div>
            <div className="summary-row available">
              <span>Your Balance:</span>
              <strong>{balance} wikipenny</strong>
            </div>
          </div>

          <div className="info-box">
            <p>✓ Your opponent must accept these exact terms</p>
            <p>✓ Both players' wagers are deducted upon acceptance</p>
            <p>✓ You must complete all games before playing another challenge</p>
            <p>✓ Winner takes the combined wagers after platform charge</p>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onCancel}>Cancel</button>
          <button 
            className="btn-primary" 
            onClick={handleCreate}
            disabled={!canCreate}
          >
            Create Real Challenge
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChallengeCreate;

